import Vue from 'vue'
import '@/styles/index.scss'
import App from './App'
import router from './router'
// import 'bootstrap/dist/css/bootstrap.min.css'
import 'swiper/dist/css/swiper.min.css'
import * as tools from './utils/tools'

Vue.config.productionTip = false
// 路由跳转后页面滚动条置顶
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})
Vue.prototype.$tools = tools
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js